import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { PollService } from '@app/services/poll/poll.service';
import { RunExperimentService } from "@services/run-experiment/run-experiment.service"
import { API_CONFIG, EXPERIMENT_RUNS_CONFIG } from '@env/environment';

@Component({
    selector: 'app-run-experiment',
    templateUrl: './run-experiment.component.html',
    styleUrls: ['./run-experiment.component.scss'],
})

export class RunExperimentComponent {
    private pollingSubscription: Subscription | undefined;
    private tenSeconds = 10000;

    constructor(private pollService: PollService, private runExperimentService: RunExperimentService) { }
    public onClick(): void {
        this.runExperimentService.createRunExperiment().subscribe((response) => {
            if (response) {
                if (response.data) {
                    if (response.data.experimentRunId) {
                        this.startPolling(response.data.experimentRunId);
                    }
                }
            }
        });
    }

    private startPolling(id: string): void {
        this.pollingSubscription = this.pollService.pollServer(this.tenSeconds, API_CONFIG.host + EXPERIMENT_RUNS_CONFIG.api.status.replace(':id', id)).subscribe(
            (response) => {
                if (response && response.body && response.body.data) {
                    if (response.body.data.status === 'completed') {
                        this.stopPolling();
                    }
                }
            }
        );
    }

    private stopPolling(): void {
        if (this.pollingSubscription) {
            this.pollingSubscription.unsubscribe();
        }
    }

    ngOnDestroy(): void {
        this.stopPolling();
    }
}